export { default as ptBr } from 'apexcharts/dist/locales/pt-br.json'

export type DefaultTypographyType = {
  fontSize: string,
  fontFamily: string,
  fontWeight: number
}

export const defaultTypography: DefaultTypographyType = {
  fontSize: '12px',
  fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
  fontWeight: 400
}

export const seriesColors: string[] = ['#06BAB2', '#EF6167', '#2D4054', '#787878']
export const labelsColors: string[] = ['#4B4B4B', '#ffffff', '#ffffff', '#ffffff']
